<div class="send-scam-warning mb-20">
	<div class="send-scam-warning__title  mb-10">
		{{ description }}
	</div>
	<a [href]="getReadMoreUrl()" (click)="clickReadMoreUrl()" target="_blank" class="send-scam-warning__link">
		<strong>{{ "more_information" | translate }}</strong>
	</a>
</div>